// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"b5903a529bd03417c710","655":"af73357f9eb1d07aec50"}[chunkId] + ".js";
};